import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

export const useViewProductQuery = ({ page = 1, limit = 10, q = "" } = {}) => {
  const trimmedQ = q.trim();

  return useQuery({
    queryKey: ["viewProduct", page, limit, trimmedQ],
    queryFn: async () => {
      const params = { page, limit };
      if (trimmedQ) params.q = trimmedQ;

      const res = await api.get("/product/list", { params });
      const parsed = parsePaginatedResponse(
        res.data,
        ["products", "product"],
        limit
      );
      return {
        products: parsed.items,
        pagination: parsed.pagination,
      };
    },
    placeholderData: (previousData) => previousData,
    staleTime: 60_000,
  });
};
